import React from 'react';
import styles from './Dashboard.module.scss';
import config from '../../config/config';

const RMDCalculatorEntry = ({ preRMDEligible = true }) => {
  return (
    <div
      className={`${styles['calculator-rmd-entry-container']} ${
        !preRMDEligible && styles['calculator-rmd-container-inherited']
      }`}
    >
      <div className={styles['calculator-rmd-heading']}>
        <div className={styles['calculator-rmd-title']}>Calculate Your RMD</div>
        <div className={styles['calculator-rmd-sub-title']}>
          Use the RMD Calculator Tool to calculate your RMD for the year. Please
          note that this tool is for estimating purposes only and is based
          solely on the values you enter.
        </div>
      </div>
      <div className={styles['calculator-rmd-button-container']}>
        <a
          className={styles['clickable-button']}
          href={`${config.url}/usis/rmd-tool/calculator`}
        >
          Calculate My RMD
        </a>
      </div>
    </div>
  );
};

export default RMDCalculatorEntry;
